


















































































import { mixins, Component, Watch } from 'nuxt-property-decorator';
import FocusLock from 'vue-focus-lock';
import clickOutside from '@/directives/click_outside';
import UniversalSearchMixin from '@/components/common/UniversalSearch/UniversalSearchMixin';
import UniversalSearchSuggestions from '@/components/common/UniversalSearch/UniversalSearchSuggestions.vue';
import UniversalSearchHint from '@/components/common/UniversalSearch/UniversalSearchHint.vue';
import DualRingLoader from '@/components/common/DualRingLoader.vue';
import SearchIcon from '@/components/common/UniversalSearch/images/search.vue.svg';
import ArrowIcon from '@/components/common/UniversalSearch/images/arrow-right.vue.svg';
import ScrollLock from '@/components/utils/browser/scrollLock';
import ProgressBar from '@/components/utils/browser/nuxtLoadingProgressBar';
import { handleFocusInElement, isFocusInsideElement } from '@/components/utils/browser/keyboardNavigation';
import { SALEGPT_LANDING_URL } from '@/components/common/UniversalSearch/constants';

@Component<UniversalSearch>({
  directives: {
    'click-outside': clickOutside,
  },
  components: {
    FocusLock,
    DualRingLoader,
    SearchIcon,
    ArrowIcon,
    UniversalSearchSuggestions,
    UniversalSearchHint,
  },
})
export default class UniversalSearch extends mixins(UniversalSearchMixin) {
  isExpandable: boolean = false;
  isFocused: boolean = false;
  searchQuery: string = '';
  SALEGPT_LANDING_URL: string = SALEGPT_LANDING_URL;

  isSearchResultsPage(path = this.$route.path) {
    return path?.startsWith('/search');
  }

  // For mobile on search page - we must show bar, but without scroll-lock etc
  get isSoftExpand() {
    return this.isSearchResultsPage() && this.$breakpoint.xs;
  }

  get isValidSearchQuery() {
    return this.searchQuery.trim().length >= this.minSearchChars;
  }

  get placeholder() {
    if (this.isFocused) return '';
    return 'Ask SalesGPT your toughest sales questions';
  }

  handleFocus() {
    this.isFocused = true;
    this.handleExpand();
    this.$analytics.logEvent('salesgpt__bar__click');
  }

  handleBlur() {
    this.isFocused = false;
  }

  handleSuggestionSelect(suggestion: string) {
    this.searchQuery = suggestion;
    this.handleShowResults();
  }

  handleExpand() {
    this.isExpandable = true;

    // Focus on input on mobile when open
    if (this.$breakpoint.xs && !this.isSoftExpand) {
      this.$nextTick(() => {
        (this.$refs.input as HTMLInputElement)?.focus();
      });
    }

    if (!this.isSoftExpand) {
      // ScrollLock.enable();
      ProgressBar.hide();
    }
  }

  handleCollapse() {
    if (!this.isExpandable) return;
    this.isExpandable = false;

    if (this.isSoftExpand) return;
    ScrollLock.disable();
    ProgressBar.show();
  }

  handleEscape() {
    // If focus is inside results, focus on search input
    if (isFocusInsideElement(this.$refs.results as HTMLElement)) {
      (this.$refs.input as HTMLInputElement)?.focus();
      return;
    }

    this.handleCollapse();
    this.searchQuery = '';
    (this.$refs.input as HTMLInputElement)?.blur();
  }

  handleKeyboardNavigation(type: 'up' | 'down') {
    if (this.isSearching) return;
    handleFocusInElement(this.$refs.universalSearch as HTMLElement, type === 'up' ? -1 : 1);
  }

  handleShowResults() {
    const query = this.searchQuery.trim();
    if (query) {
      this.$router.push(`/search?query=${encodeURIComponent(query)}`, () => {
        if (this.$breakpoint.xs) {
          !this.isSoftExpand && this.handleCollapse();
          return;
        }
        this.handleCollapse();
      });
      this.$analytics.logEvent('salesgpt__query__execute', { query });
    }
  }

  beforeDestroy() {
    this.handleCollapse();
  }

  @Watch('$route.query.query', { immediate: true })
  handleSearchQueryChange(newValue: string) {
    this.searchQuery = newValue ?? '';
  }

  @Watch('$route.path', { immediate: true })
  handlePageChange(newValue: string) {
    // Clear search when navigating, but not on search result page
    if (!this.isSearchResultsPage(newValue)) {
      this.searchQuery = '';
      this.$breakpoint.xs && this.handleCollapse();
    }

    // Show opened search bar on mobile on search page
    // Note: on the first load $breakpoint.xs is alaways true even for a desktop, we can't use it here
    if (this.isSearchResultsPage(newValue) && this.$device.isMobile && this.searchQuery) {
      this.handleExpand();
    }
  }
}
